import { useState, useEffect, useCallback } from 'react'

export function usePlayback(duration = 120000) {
  const [currentTime, setCurrentTime] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const [playbackSpeed, setPlaybackSpeed] = useState(1)

  // Advance time while playing
  useEffect(() => {
    if (!isPlaying || duration <= 0) return

    const interval = setInterval(() => {
      setCurrentTime(prev => {
        const next = prev + (100 * playbackSpeed)
        if (next >= duration) {
          setIsPlaying(false)
          return duration
        }
        return next
      })
    }, 100)

    return () => clearInterval(interval)
  }, [isPlaying, playbackSpeed, duration])

  const play = useCallback(() => {
    if (currentTime >= duration) {
      setCurrentTime(0)
    }
    setIsPlaying(true)
  }, [currentTime, duration])

  const pause = useCallback(() => {
    setIsPlaying(false)
  }, [])

  const togglePlay = useCallback(() => {
    if (isPlaying) {
      pause()
    } else {
      play()
    }
  }, [isPlaying, play, pause])

  const seek = useCallback((time) => {
    setCurrentTime(Math.max(0, Math.min(time, duration)))
  }, [duration])

  const reset = useCallback(() => {
    setIsPlaying(false)
    setCurrentTime(0)
  }, [])

  const cycleSpeed = useCallback(() => {
    setPlaybackSpeed(s => s === 1 ? 2 : s === 2 ? 5 : 1)
  }, [])

  return {
    currentTime,
    duration,
    isPlaying,
    playbackSpeed,
    play,
    pause,
    togglePlay,
    seek,
    reset,
    cycleSpeed,
  }
}